import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiStatus } from "../../utils/api.types";
import {
  fetchTransfers,
  fetchTransferById,
  addTransfer,
  updateTransfer,
  dispatchTransfer,
  receiveTransfer,
  cancelTransfer,
  reverseTransfer,
} from "./stockTransferThunk";

interface TransferSliceState {
  transfers: any[];
  transferDetails: any;
  rowCount: number;
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: TransferSliceState = { transfers: [], transferDetails: {}, rowCount: 0, status: ApiStatus.IDLE, errorMessage: "" };

const stockTransferSlice = createSlice({
  name: "stockTransfer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransfers.pending, (state) => { state.status = ApiStatus.LOADING; })
      .addCase(fetchTransfers.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        // Server-side paginated: { data, total }. Falls back to a plain array for safety.
        const p = action.payload;
        state.transfers = Array.isArray(p) ? p : p?.data || [];
        state.rowCount = Array.isArray(p) ? p.length : p?.total || 0;
      })
      .addCase(fetchTransfers.rejected, (state, action) => { state.status = ApiStatus.FAILED; state.errorMessage = action.error.message; })

      .addCase(fetchTransferById.fulfilled, (state, action: any) => { state.transferDetails = action.payload || {}; })

      // NOTE: error toasts are handled globally by the axios response interceptor
      // (it shows the real backend message). The per-action `.rejected` toasts were
      // removed because they duplicated it with the generic "Request failed…" text.
      .addCase(addTransfer.fulfilled, () => { toast.success("Transfer created"); })
      .addCase(updateTransfer.fulfilled, () => { toast.success("Transfer updated"); })
      .addCase(dispatchTransfer.fulfilled, () => { toast.success("Transfer dispatched"); })
      .addCase(receiveTransfer.fulfilled, () => { toast.success("Transfer received"); })
      .addCase(cancelTransfer.fulfilled, () => { toast.success("Transfer cancelled"); })
      .addCase(reverseTransfer.fulfilled, (state, action: any) => { toast.success(`Transfer reversed (${action.payload?.reversedCount ?? 0} movements)`); });
  },
});

export default stockTransferSlice.reducer;
